import { useState } from 'react';
import { faqList } from '@/mocks/blackMaterial';
import Reveal from './Reveal';

export default function FaqBlock() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-28 mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
      <div className="overflow-hidden rounded-lg ring-1 ring-[#e6dbc9]">
        <div className="grid lg:grid-cols-12">
          {/* 左侧醒目引导 */}
          <div className="relative overflow-hidden bg-[#c83424] p-6 md:p-8 lg:col-span-4">
            <span className="pointer-events-none absolute -right-8 -top-8 font-display text-[140px] font-black leading-none text-white/10">
              ?
            </span>
            <p className="text-xs font-bold tracking-[0.3em] text-white/80">GUIDE · 阅读与信任</p>
            <h2 className="font-display mt-4 text-3xl font-black leading-tight text-white md:text-4xl">
              关于实锤、可信度
              <br />与本站规则
            </h2>
            <p className="mt-4 text-sm leading-7 text-[#fbe9e2]">
              深挖内幕不是情绪化跟风。读懂这几条规则，你就能更快判断一条线索到底有多「硬」，也明白为什么有些内容会被脱敏。
            </p>
            <div className="mt-6 flex items-center gap-2 rounded-md bg-white/15 px-3 py-2 text-xs font-semibold text-white">
              <i className="ri-verified-badge-fill"></i>全站内容人工复核 · 勘误通道开放
            </div>
          </div>

          {/* FAQ 手风琴 */}
          <div className="bg-white p-5 md:p-8 lg:col-span-8">
            <div className="space-y-3">
              {faqList.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q} className="overflow-hidden rounded-md border border-[#e6dbc9]">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className={`flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-3.5 text-left transition ${
                        isOpen ? 'bg-[#f6f1e8]' : 'bg-white hover:bg-[#faf6ee]'
                      }`}
                    >
                      <span className="flex items-center gap-3 text-sm font-bold text-[#332c24]">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#fdeee9] text-[11px] font-black text-[#c83424]">
                          Q{i + 1}
                        </span>
                        {f.q}
                      </span>
                      <i
                        className={`ri-add-line shrink-0 text-lg text-[#c83424] transition-transform ${isOpen ? 'rotate-45' : ''}`}
                      ></i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-4 pb-4 pl-[52px] text-[13px] leading-6 text-[#5d5245]">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}